// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  key: "UnemploymentSlope__key",
  keyAll: "UnemploymentSlope__keyAll",
  keyExposed: "UnemploymentSlope__keyExposed",
  keyOther: "UnemploymentSlope__keyOther",
  svg: "UnemploymentSlope__svg",
  tick: "UnemploymentSlope__tick",
  unit: "UnemploymentSlope__unit",
  valExposed: "UnemploymentSlope__valExposed",
  valOther: "UnemploymentSlope__valOther",
  wrap: "UnemploymentSlope__wrap",
  year: "UnemploymentSlope__year",
};
